export default __webpack_public_path__ + "static/media/gsm_1.fa3206c5.svg";